@if (toggled | async) {
  @if (filter.searchable) {
    <div
      class="complex-filter-checkbox-list__search"
      [ngClass]="'complex-filter-checkbox-list__search--' + nestingDisplayMode"
    >
      <ftr-search-input
        name="searchTerms"
        [required]="false"
        [ngFormControl]="searchControl"
        autocomplete="off"
        label="Search"
        [clearType]="searchInputClear.Cross"
      ></ftr-search-input>
    </div>
  }
  <ftr-animated-remote
    [remote]="viewModel"
    [loadingTemplate]="loading"
    [failureTemplate]="failure"
    [emptyTemplate]="success"
    [successTemplate]="success"
  >
    <ng-template #loading>
      <ftr-complex-filter-loading></ftr-complex-filter-loading>
    </ng-template>
    <ng-template #failure>
      <ftr-complex-filter-error [refreshOptions]="refreshOptions"></ftr-complex-filter-error>
    </ng-template>
    <ng-template #success>
      <div class="complex-filter-checkbox-list" [ngClass]="'complex-filter--' + nestingDisplayMode">
        @if (filteredOptions.length) {
          <form class="complex-filter-checkbox-list__form">
            @for (option of filteredOptions; track option) {
              <ftr-checkbox [control]="getCheckboxFormControl(option)" [label]="option.key"></ftr-checkbox>
            }
          </form>
        }
        @if (searchTerm && !filteredOptions.length) {
          <ftr-complex-filter-empty [searchTerm]="searchTerm"></ftr-complex-filter-empty>
        }
      </div>
    </ng-template>
  </ftr-animated-remote>
}
